import Billing from "./Billing";
import Comments from "./Comments";
import Dialin from "./Dialin";
import Elog from "./Elog";
import Info from "./Info";
import Recurrence from "./Recurrence";
import Revisions from "./Revisions";

const Accordions = {
  Billing,
  Comments,
  Dialin,
  Elog,
  Info,
  Revisions,
  Recurrence,
};

export default Accordions;
